document.addEventListener('DOMContentLoaded', function () {
  var toast = document.getElementById('aw-cart-toast');

  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('aw-show');
    setTimeout(function () { toast.classList.remove('aw-show'); }, 2200);
  }

  // Tap-to-flip for touch devices (hover still works on desktop via CSS)
  document.querySelectorAll('.aw-card').forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (e.target.closest('.aw-add-btn') || e.target.closest('.aw-size-select')) return;
      card.classList.toggle('aw-flipped');
    });
  });

  // Let the "View full page" link navigate normally without the card
  // re-toggling its flip state on the same click.
  document.querySelectorAll('.aw-view-link').forEach(function (link) {
    link.addEventListener('click', function (e) { e.stopPropagation(); });
  });

  // Keep add-to-cart variant id in sync with size selector
  document.querySelectorAll('.aw-size-select').forEach(function (select) {
    select.addEventListener('click', function (e) { e.stopPropagation(); });
    select.addEventListener('change', function () {
      var card = select.closest('.aw-card');
      var btn = card.querySelector('.aw-add-btn');
      if (btn) btn.dataset.variantId = select.value;
    });
  });

  // Add to cart via Shopify AJAX Cart API
  document.querySelectorAll('.aw-add-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          showToast('Added to cart');

          // Theme-agnostic: broadcast common cart-update events most OS 2.0
          // themes (Dawn, Spotlight, and others) listen for.
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.body.dispatchEvent(new CustomEvent('cart:updated'));

          // Try known custom-element drawer patterns across themes.
          var drawer = document.querySelector('cart-drawer, cart-notification, [data-cart-drawer]');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else if (drawer && drawer.classList) {
            drawer.classList.add('is-open', 'active', 'open');
          }
          // If none of the above applied, the toast above is still the
          // user-visible confirmation, so nothing silently fails.
        })
        .catch(function () {
          showToast('Could not add — try again');
        })
        .finally(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  });
});